import React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { Divider, Grid } from '@mui/material'
import { Link } from 'react-router-dom'
import {
  createMarkup,
  isExternalLink,
  routeHandler,
} from '../../utils/helper/helper'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

interface SimpleCardProps {
  title?: string
  subTitle?: string
  bottomAction?: string
  url?: string
  params?: string
  elementID: string
  className?: string
  disableBottomLink?: boolean
  showDevider?: boolean
}

export default function CommonCard(props: SimpleCardProps) {
  const {
    title = '',
    subTitle = '',
    bottomAction = '',
    url = '',
    params = '',
    elementID,
    showDevider = true,
    disableBottomLink = false,
  } = props

  function bottomActionButton() {
    return (
      <Grid className={'bottom-action-container'} tabIndex={-1}>
        <Grid container className={'bottom-action-section'} tabIndex={-1}>
          <Typography
            variant={'h3'}
            component={'h3'}
            id={`${elementID}-h3-bottom-title`}
            className={'bottom-title'}
            tabIndex={-1}
          >
            {bottomAction}
          </Typography>
          <div className={'card-title-img-hover'}>
            <ArrowForwardIcon />
          </div>
        </Grid>
      </Grid>
    )
  }

  function cardTitle() {
    return (
      <Typography
        className={'card-title'}
        variant={'h3'}
        component={'h3'}
        id={`${elementID}-h3-card-title`}
      >
        {title}
      </Typography>
    )
  }

  function getLink() {
    return `${params ? `${url}/${params}` : url}`
  }

  function renderTitle() {
    if (url) {
      if (isExternalLink(url)) {
        return (
          <Grid className={'card-title-link-section'}>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              onClick={(e) => routeHandler(e, url, params)}
              aria-label={title}
              tabIndex={0}
              id={`${elementID}-Card_title`}
            >
              {cardTitle()}
            </a>
            <div className={'card-title-img-hover'}>
              <ArrowForwardIcon />
            </div>
          </Grid>
        )
      } else {
        return (
          <Grid className={'card-title-link-section'}>
            <Link
              aria-label={title}
              tabIndex={0}
              id={`${elementID}-Card_title`}
              to={getLink()}
            >
              {cardTitle()}
            </Link>
            <div className={'card-title-img-hover'}>
              <ArrowForwardIcon />
            </div>
          </Grid>
        )
      }
    }
    return cardTitle()
  }

  return (
    <Card
      className={`${
        props.className ? props.className : ''
      } card common-card-container`}
    >
      <CardContent className="card-sections">
        {renderTitle()}
        {showDevider ? (
          <Divider className="divider-line" id={`${elementID}-divider-line`} />
        ) : (
          ''
        )}
        <div className="bottom-section">
          <div
            dangerouslySetInnerHTML={createMarkup(subTitle)}
            className={'card-sub-title'}
            id={`${elementID}-card-sub-title`}
          />
          {url && !disableBottomLink ? (
            isExternalLink(url) ? (
              <a
                tabIndex={disableBottomLink ? -1 : 0}
                onClick={(e) => routeHandler(e, url, params)}
                aria-label={bottomAction}
                className={'card-bottom-action'}
                id={`${elementID}-${elementID}-bottom-title`}
                href={getLink()}
              >
                {bottomActionButton()}
              </a>
            ) : (
              <Link
                tabIndex={disableBottomLink ? -1 : 0}
                className={'card-bottom-action'}
                to={getLink()}
                aria-label={bottomAction}
              >
                {bottomActionButton()}
              </Link>
            )
          ) : (
            <Grid
              id={`${elementID}-bottom-title`}
              className={'card-bottom-action'}
            >
              {bottomActionButton()}
            </Grid>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
